import { createReducer, on } from '@ngrx/store';
import { saveFullTableState, saveTableLazyLoadEvent, clearTableLazyLoadEvent } from './app.action';
import { FilterMetadata } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { createDefaultTableState } from '../../../utils/table.utils';

export interface FullTableState {
  first: number;
  rows: number;
  sortField?: string;
  sortOrder: number;
  filters: { [key: string]: FilterMetadata | FilterMetadata[]};
  globalFilter?: string;
}

export interface AppState {
  tableState: FullTableState;
  savedLazyLoadEvents: { [componentName: string]: FullTableState };
}

export const initialTableState: FullTableState = createDefaultTableState()

export const initialAppState: AppState = {
  tableState: initialTableState,
  savedLazyLoadEvents: {}
}

export const appReducer = createReducer(
  initialAppState,
  on(saveFullTableState, (state, { tableState }) => ({
    ...state,
    tableState: {
      ...state.tableState,
      ...tableState,
    }
  })),
  on(saveTableLazyLoadEvent, (state, { lazyLoadEvent, componentName }) => ({
    ...state,
    savedLazyLoadEvents: {
      ...state.savedLazyLoadEvents,
      [componentName]: lazyLoadEvent
    }
  })),
  on(clearTableLazyLoadEvent, (state, { componentName }) => {
    const { [componentName]: removed, ...remainingEvents } = state.savedLazyLoadEvents;
    return {
      ...state,
      savedLazyLoadEvents: remainingEvents
    };
  })
);
